import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { monoFont } from '../../theme';

const deltaToneColors = {
	up: { fg: 'success.main', bg: 'success.light' },
	down: { fg: 'error.main', bg: 'error.light' },
	flat: { fg: 'text.secondary', bg: 'action.hover' }
};

// Tarjeta de KPI del panel principal — ver README.md (KpiCard).
const KpiCard = ({ icon, iconBg, iconColor, value, label, delta, deltaTone = 'flat', onClick, sx }) => {
	const toneSx = deltaToneColors[deltaTone] || deltaToneColors.flat;

	return (
		<Paper
			onClick={onClick}
			sx={{ padding: '17px 18px', cursor: onClick ? 'pointer' : 'default', ...sx }}
		>

			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
				<Box
					sx={{
						width: 36,
						height: 36,
						borderRadius: '10px',
						backgroundColor: iconBg,
						color: iconColor,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					{icon}
				</Box>
				{delta ? (
					<Box
						component="span"
						sx={{
							fontSize: 11.5,
							fontWeight: 600,
							color: toneSx.fg,
							backgroundColor: toneSx.bg,
							padding: '2px 8px',
							borderRadius: '20px'
						}}
					>
						{delta}
					</Box>
				) : null}
			</Box>
			<Typography sx={{ fontFamily: monoFont, fontSize: 25, fontWeight: 600, color: 'text.primary', letterSpacing: '-.5px', lineHeight: 1 }}>
				{value}
			</Typography>
			<Typography sx={{ fontSize: 12.5, color: 'text.secondary', marginTop: '6px', fontWeight: 500 }}>{label}</Typography>
		</Paper>
	);
};

export default KpiCard;
